
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../WebCalendar_TS/MainProperties/MainProperties";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import SyncFusion_Main from '../SyncFusion/SyncFusion_Main';
import FileTile from '../../FileDashboard/FileTile';
import _EntityViewMixin from '../../../moreCore/UI/EntityBased/EntityView/EntityView';

import { FileDashboard } from "../../FileDashboard/FileDashboardTypes";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";

class DKPHB_Main extends compose(SyncFusion_Main) {


    private itemView: MdsLax<InstanceType<typeof _EntityViewMixin<any>>> = null;

    protected _onCalendarCreated() {
        this.mainProperties.on("itemViewCreated", lang.hitch(this, this._onItemViewCreated));
    }


    protected _onClick_CalendarCell(data: WebcalendarTypes.CellClickData_Simple) {

    }

    showItemDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {
        this.currentItem = {
            Classname: item.Classname,
            ID: item.id
        };
        super.showItemDetails.apply(this, arguments as any);

        console.log("showItemDetails", item);

    }

    private _onItemViewCreated(itemView: MdsLax<InstanceType<typeof _EntityViewMixin<any>>>) {
        this.itemView = itemView;
        //console.debug("_onItemViewCreated", itemView);
        this.hasUserRole("RD_ProjectInfo", lang.hitch(this, this._onPrivilege_PI, itemView.getEntityId()));
        this.hasUserRole("RD_ProjectOverview", lang.hitch(this, this._onPrivilege_PO, itemView.getEntityId()));
        this.hasUserRole("RD_TravelInfo", lang.hitch(this, this._onPrivilege_TI, itemView.getEntityId()));

    }
    private currentItem: more.EntityAPIResult = null;

    private _onPrivilege_PO(checkedId: string, result: boolean) {

        if (checkedId != this.currentItem?.ID) return;

        if (this.itemView) {

            if (result) {

                this.itemView.addButton(
                    "RD_ProjectOverview",
                    this.translate("Label_Report_ProjectOverview"),
                    //lang.hitch(this, this._onClick_OpenFileTile, "RD_ProjectOverview", this.translate("Label_Report_ProjectOverview")),
                    lang.hitch(this, this._onRequest_Report, "RD_ProjectOverview"),
                    null,
                    "cL3",
                    "fas fa-print",
                    false,
                    "left last",
                    true
                );
            } else {
                this.itemView.removeButton("RD_ProjectOverview");
            }
        }
    }
    private _onPrivilege_PI(checkedId: string, result: boolean) {
        if (checkedId != this.currentItem?.ID) return;

        if (this.itemView) {

            if (result) {
                this.itemView.addButton(
                    "RD_ProjectInfo",
                    this.translate("Label_Report_ProjectInfo"),
                    //lang.hitch(this, this._onClick_OpenFileTile, "RD_ProjectInfo", this.translate("Label_Report_ProjectInfo")),
                    lang.hitch(this, this._onRequest_Report, "RD_ProjectInfo"),
                    null,
                    "cL3",
                    "fas fa-print",
                    false,
                    "left last",
                    true
                );
            } else {
                this.itemView.removeButton("RD_ProjectInfo");
            }
        }
    }
    private _onPrivilege_TI(checkedId: string, result: boolean) {

        if (checkedId != this.currentItem?.ID) return;

        if (this.itemView) {

            if (result) {
                this.itemView.addButton(
                    "RD_TravelInfo",
                    this.translate("Label_Report_TravelInfo"),
                    //lang.hitch(this, this._onClick_OpenFileTile, "RD_ProjectInfo", this.translate("Label_Report_ProjectInfo")),
                    lang.hitch(this, this._onRequest_Report, "RD_TravelInfo"),
                    null,
                    "cL3",
                    "fas fa-route",
                    false,
                    "left last",
                    true
                );
            } else {
                this.itemView.removeButton("RD_ProjectInfo");
            }
        }
    }

    private _onClick_OpenFileTile(buttonName: string, heading: string) {

        // Problem bei Filetile: da wird das Projekt als Filterparameter abgefragt... obwohl wir ja schon auf einem Item stehen.

        let data: any & FileDashboard.TileRequestData = {
            targetTile: buttonName,
            hideProjectParam: true
        };

        let dlg = new GenericDialog();

        dlg.show("",
            heading,
            null,
            null,
            "close",
            null
        );

        this.StandbyStart(dlg.contentContainer);

        this.RequestManager.callfunction("Webtool_API_ReportDashboard__GetTile",
            data,
            lang.hitch(this, this._onTileLoaded, dlg, buttonName),
            lang.hitch(this, this._onTileLoadError, dlg, buttonName)
        );
    }

    private _onTileLoaded(dlg: MdsLax<InstanceType<typeof GenericDialog>>, buttonname: string, data: FileDashboard.TileData) {
        this.mainProperties.itemView.enableButton(buttonname);

        this.StandbyStop();

        if (!dlg?.is_active) return;

        let fileTile = new FileTile();
        fileTile.setData(data);
        fileTile.startup();

        dlg.addNodeToContent(fileTile.domNode);

    }

    private _onTileLoadError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, buttonname: string, error: more.requestErrorMessage) {
        this.mainProperties.itemView.enableButton(buttonname);

        alert(error.Message);
        dlg.close(-1, true);
    }

    private _onRequest_Report(buttonName: string) {
        if (this.mainProperties?.itemView) {
            this.mainProperties.itemView.disableButton(buttonName);
        }

        let data = {
            entityID: this.currentItem.ID,
            Classname: this.currentItem.Classname,
            report: buttonName
        };

        this.StandbyStart(this.itemView?.domNode);

        this.RequestManager.callfunction("Webtool_API_Reports__RequestReport",
            data,
            lang.hitch(this, this._onDownloadReady, buttonName),
            lang.hitch(this, this._onReportError, buttonName)
        )
    }

    private _onDownloadReady(buttonname: string, response: FileFinder.FileDescriptor) {
        this.mainProperties.itemView.enableButton(buttonname);
        this.StandbyStop();

        //console.log("_onClick_Download", entity);
        location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
            response.downloadKey,
            response.filename,
            response.extension);

    }

    private _onReportError(buttonname: string, error: more.requestErrorMessage) {
        this.mainProperties.itemView.enableButton(buttonname);
        this.StandbyStop();

        alert(error.Message);
    }

    protected _setupMainPropertes(): void{
        super._setupMainPropertes.apply(this, arguments as any);

    }


    protected _preparePanels(): void {
        super._preparePanels.apply(this, arguments as any);

    }


    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }

}

export default mdsWidget(DKPHB_Main);
